<div class="flex flex-col pt-2 pr-2 pl-2 pb-2 border-box">
  <h4 class="text-xl font-bold mt-2">
    {{ '#DOCUMENTATION.DIALOG.TITLE' | translate }}
  </h4>
  <span class="text-sm color-light">{{
    '#DOCUMENTATION.DIALOG.DESC' | translate
  }}</span>

  <div class="soft-scroll soft-scroll-vertical w-full mt-2 border-box">
    @if (loading$ | async) {
      <soft-loading-spinner class="spin"></soft-loading-spinner>
    } @else {
      @if (recentObjects$ | async; as recentObjects) {
        <ul class="soft-list mt-2">
          @for (object of recentObjects; track object) {
            <li
              class="soft-list-item custom-item"
              (click)="close(object)"
              >
              <strong>{{ object.name }}</strong>
              <div class="text-sm color-light mt-1">{{ object.number }}</div>
            </li>
          }
        </ul>
      }
    }

  </div>
</div>
